import { render, staticRenderFns } from "./MKasaSaleItems.vue?vue&type=template&id=da9463f4"
import script from "./MKasaSaleItems.vue?vue&type=script&lang=js"
export * from "./MKasaSaleItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports